module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Suset1-f978d029ffc8fe71c02ed7ba04c2025d.svg";